module.exports = __webpack_public_path__ + "static/media/icon_1.8c11e0e4.png";